import { NgModule } from "@angular/core";

import { DateDigitsMaskDirective } from "./date-digits-mask.directive";

/**
 * Módulo próprio, e não só uma declaração no `SharedModule`: o calendário
 * novo não importa o `SharedModule` de propósito (arrasta modais que não usa)
 * e também precisa da máscara. Uma diretiva só pode ser declarada num módulo,
 * por isso os dois importam este.
 */
@NgModule({
  declarations: [DateDigitsMaskDirective],
  exports: [DateDigitsMaskDirective],
})
export class DateDigitsMaskModule {}
